import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getCartList } from 'redux/actions';

import CheckoutDetails from "./CheckoutDetails";
import CheckoutInfo from "./CheckoutInfo";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import "./checkout.scss";
import { useApiDefaults } from 'hooks/useApiDefaults';

const Checkout = () => {
  const breadcrumbList = [{ lable: "Checkout", link: "" }];
  const dispatch = useDispatch();
  const apiDefaults = useApiDefaults()
  const isUserLoggedIn = useSelector(({ user }) => user?.isUserLoggedIn);

  useEffect(() => {
    if (isUserLoggedIn) {
      dispatch(getCartList(apiDefaults));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoggedIn ]);

  return (
    <>
           <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={`Checkout`} />

      <CheckoutDetails />

      <CheckoutInfo />
    </>
  );
};
export default Checkout;
